import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Input } from 'antd'
import { AppstoreOutlined, DatabaseOutlined, SearchOutlined } from '@ant-design/icons'
import { Titles } from '../../layouts/Titles'
import { CardList, ListChip, ListToolbar, ListToolbarField } from '../../components/card_list/CardList'
import { ProjectCard } from '../../components/project_card/ProjectCard'
import userController from '../user/controllers/user.controller'
import i from '../../translations/i'
import controller, { SuperProject } from './super.controller'
import { SuperGuard } from './SuperGuard'

const DatabaseChip = ({ project }: { project: SuperProject }) => {
    if (project.has_database === null) return <ListChip icon={<DatabaseOutlined />}>{i.t('superAdmin:projects.unknownDatabase')}</ListChip>
    if (project.has_database) return null

    return (
        <ListChip tone="warning" icon={<DatabaseOutlined />} tooltip={i.t('superAdmin:projects.noDatabaseHint')}>
            {i.t('superAdmin:projects.noDatabase')}
        </ListChip>
    )
}

const ProjectsList = observer(() => {
    useEffect(() => {
        controller.getProjects()
    }, [])

    return (
        <CardList
            items={controller.filteredProjects}
            loading={controller.projectsLoading}
            count={controller.filteredProjects.length}
            toolbar={
                <ListToolbar>
                    <ListToolbarField wide>
                        <Input
                            allowClear
                            prefix={<SearchOutlined />}
                            placeholder={i.t('superAdmin:projects.search')}
                            value={controller.projectsSearch}
                            onChange={e => controller.projectsSearch = e.target.value}
                        />
                    </ListToolbarField>
                </ListToolbar>
            }
            empty={{ icon: <AppstoreOutlined />, title: i.t('superAdmin:projects.empty') }}
            renderItem={(project: SuperProject) => (
                <ProjectCard
                    project={project}
                    // Строка kssettings есть, а базы бандла нет: проект не откроется
                    disabled={project.has_database === false}
                    chips={<>
                        {!!project.wl_id && <ListChip>{`WL ${project.wl_id}`}</ListChip>}
                        <DatabaseChip project={project} />
                    </>}
                    onOpen={() => userController.changeProject(project.id)}
                />
            )}
        />
    )
})

export const SuperProjects = () => (
    <>
        <Titles
            title={i.t('superAdmin:hub.projects')}
            breadcrumb={[
                { title: i.t('def:settings'), href: '/settings' },
                { title: i.t('superAdmin:title') },
                { title: i.t('superAdmin:hub.projects') },
            ]}
        />
        <SuperGuard>
            <ProjectsList />
        </SuperGuard>
    </>
)
